import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import actionProps from 'actions';
import { PasswordReset } from 'resources';

import { Link } from 'react-router';
import { Alert, Button, FormGroup } from 'react-bootstrap';
import { FaIcon } from 'components/utilities';

class ForgotPasswordIndex extends React.Component {

  constructor() {
    super();

    this.state = {
      validationError: null,
      submitting: false,
      sentResetEmail: false,
    };
  }

  componentDidMount() {
    this.focusInput();
  }

  onPasswordResetCreate = () => {
    this.setState({
      sentResetEmail: true,
      submitting: false,
    });
  }

  onPasswordResetError = ({ data }) => {
    this.setState({
      validationError: data.password_reset.email,
      submitting: false,
    });

    this.focusInput();
  }

  doPasswordResetCreate = e => {
    e.preventDefault();

    const email = _.first(e.target.elements, el => (
      el.name === 'password_reset.email'
    )).value;

    this.setState({
      submitting: true,
    });

    PasswordReset.create({
      data: {
        password_reset: { email },
      },
      onSuccess: this.onPasswordResetCreate,
      onFailure: this.onPasswordResetError,
    });
  }

  doResetErrorState = () => {
    this.setState({
      validationError: null,
    });
  }

  refInput = input => (this.input = input);

  focusInput() {
    /* eslint-disable react/no-find-dom-node */
    ReactDOM.findDOMNode(this.input).focus();
  }

  render() {
    const { validationError, sentResetEmail } = this.state;
    const { email: defaultEmail, security } = this.props.location.query;

    return (
      <div className="account-wrapper">

        <h3 className="m-b-0">Forgot your password?</h3>
        <hr className="spacer-xs" />
        <Link to="/login">&laquo; back to login</Link>

        <form
          className="form account-form account-body"
          onInput={this.doResetErrorState}
          onSubmit={this.doPasswordResetCreate}
        >

          {security && !sentResetEmail ? (
            <Alert bsStyle="warning">
              <FaIcon lock className="m-r-05" />
              We've recently upgraded GCM's security. As a result, your password will need to be reset.
            </Alert>
          ) : null}

          {sentResetEmail ? (
            <Alert bsStyle="success">An email was sent to reset your password.</Alert>
          ) : (
            <div>
              <FormGroup validationState={_.isNull(validationError) ? null : 'error'}>
                <input
                  type="text" className="form-control"
                  name="password_reset.email"
                  placeholder="Email address"
                  tabIndex={1}
                  autoFocus
                  ref={this.refInput}
                  defaultValue={defaultEmail}
                />
                {_.isNull(validationError) ? null : <span className="help-block">{validationError}</span>}
              </FormGroup>

              <FormGroup>
                <Button
                  type="submit"
                  bsStyle="secondary"
                  disabled={this.state.submitting}
                  bsSize="lg"
                  block
                  tabIndex={2}
                >Reset my password</Button>
              </FormGroup>
            </div>
          )}
        </form>

      </div>
    );
  }

}

export default connect(null, actionProps)(ForgotPasswordIndex);
